<script setup lang="ts">
import { computed } from 'vue'
import { DateTime } from 'luxon'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/stores/auth'
import HomeBannerSubjects from '~/components/banners/HomeBannerSubjects.vue'

const { t } = useI18n()
const authStore = useAuthStore()
const { user } = storeToRefs(authStore)

const greetings = computed(() => {
    const hour = Number(DateTime.local().toFormat('H'))
    if (hour < 4) return t('home.greetings.night')
    if (hour < 12) return t('home.greetings.morning')
    if (hour < 18) return t('home.greetings.afternoon')
    return t('home.greetings.evening')
})
</script>

<template>
  <header class="relative mb-12 flex-col justify-center bg-gradient-to-tr from-seagreen-40 to-custom-green to-60% text-white">
    <div class="relative z-20 mx-auto h-full w-full max-w-screen-au px-4 pb-10 pt-40 transition-all xs:pb-14 sm:px-8 sm:pt-28">
      <h1
        class="sr-only"
        v-text="t('home.title')"
      />
      <p class="fluid-text-base">
        {{ greetings }},<br>
        <span class="font-semibold fluid-text-lg">{{ user?.userData.fullName }}!</span>
      </p>
      <HomeBannerSubjects />
      <img
        src="../../assets/images/home-illustration.png"
        aria-hidden="true"
        class="absolute -bottom-10 right-0 hidden w-[350px] transition-all md:block lg:w-[400px]"
        alt=""
      >
    </div>
  </header>
</template>
